module.exports = "/_next/static/images/pl-1b9768efcf170243ac47c39bedb2aa95.svg";